import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersistedState from 'pinia-plugin-persistedstate';
import './style.css'
import App from './App.vue'
import * as Sentry from "@sentry/vue";
import router from './configs/router'
import { useLangStore } from './stores';
import Vue3Toastify, { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { APP } from './configs/app';
import Vue3Lottie from 'vue3-lottie'
// setup vue
const app = createApp(App)

// setup sentry
if (APP.sentry.dns && APP.sentry.enable) {
    Sentry.init({
        app,
        dsn: APP.sentry.dns,
        environment: APP.env,
        release: APP.version,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        beforeSend(event) {
            // Check if the event contains an HTTP 401 error
            if (event.exception?.values?.some(exception => exception.value?.includes('401'))) {
                return null; // Drop the event
            }
            return event; // Send other events
        }
    });
}

// pinia store
const pinia = createPinia();
pinia.use(piniaPersistedState);
app.use(pinia)

// i18n language
const lang = useLangStore()
lang.setLocale()
app.use(lang.i18n)

// toastify
app.use(Vue3Toastify, {
    theme: 'colored',
    limit: 3,
    position: toast.POSITION.TOP_LEFT,
    newestOnTop: true,
    clearOnUrlChange: false,
    containerClassName: '!w-auto',
    toastClassName: '!font-sans !gap-2 !min-h-full',
    bodyClassName: '!py-0 !my-0'
})

// router
app.use(router)

//Vue3Lottie
app.use(Vue3Lottie)

// mount app
app.mount('#app')